import ProductBand from './ProductBand'
import { productLines, remainingProducts, stationIsLive } from './constants'

function AddCard({ label, hint, onClick, minHeight = 96 }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ minHeight }}
      className="flex w-full flex-col items-center justify-center gap-2 rounded-[22px] border-[1.5px] border-dashed border-gray-300 text-gray-400 transition hover:border-[#e2932b] hover:bg-[#e2932b]/10 hover:text-[#e2932b]"
    >
      <span className="flex h-[30px] w-[30px] items-center justify-center rounded-full border-[1.5px] border-current text-lg leading-none">+</span>
      <span className="text-[13px] font-semibold">{label}</span>
      {hint && <span className="text-[12px] opacity-80">{hint}</span>}
    </button>
  )
}

export default function StationView({ station, levels, busyTankId, orgName, onBack, onOpenTank, onAddTank, onOpenPump, onAddPump, onToggleValve, onOpenLine, onAddLine, onEditStation }) {
  const lines = productLines(station)
  const remaining = remainingProducts(station)
  const live = stationIsLive(station)

  return (
    <div>
      <div className="mb-6 flex flex-wrap items-start justify-between gap-5">
        <div>
          {/* Below the sidebar breakpoint the rail is gone, so this is the only
              way back to the station list. */}
          <button
            type="button"
            onClick={onBack}
            className="mb-1.5 -ml-1 flex items-center gap-1 rounded-md px-1 py-0.5 text-[13px] text-gray-500 transition hover:bg-gray-100 hover:text-gray-800"
          >
            <span aria-hidden="true">‹</span> {orgName || 'All stations'}
          </button>
          <h1 className="text-[clamp(1.4rem,1.1rem+1vw,1.85rem)] font-bold tracking-[-.01em] text-gray-900">{station.name}</h1>
          <div className="mt-3 flex flex-wrap gap-2">
            {station.location && (
              <span className="rounded-full border border-gray-200 bg-white px-3 py-1.5 text-[12.5px] text-gray-600">{station.location}</span>
            )}
            <span
              className={`rounded-full px-2.5 py-1 text-[11.5px] font-semibold ${
                live ? 'bg-[#0f9d63]/10 text-[#0f9d63]' : 'bg-[#b8791f]/10 text-[#b8791f]'
              }`}
            >
              {live ? 'Live' : 'Needs setup'}
            </span>
          </div>
        </div>

        <div className="flex gap-2.5">
          {remaining.length > 0 && (
            <button
              type="button"
              onClick={onAddLine}
              className="rounded-lg bg-[#c97a1a] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#b06914]"
            >
              + Add product
            </button>
          )}
          <button
            type="button"
            onClick={onEditStation}
            className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50"
          >
            Edit station
          </button>
        </div>
      </div>

      <p className="mb-3.5 text-[11px] font-bold uppercase tracking-[.09em] text-gray-400">Product lines</p>

      {lines.length === 0 ? (
        <div className="max-w-[380px]">
          <p className="mb-4 text-[13.5px] text-gray-500">
            No products yet. Add a product to set up its tanks and pumps in one go — e.g.
            &ldquo;PMS, stored in 2 tanks, sold through 4 pumps.&rdquo;
          </p>
          <AddCard label="Add a product line" onClick={onAddLine} minHeight={120} />
        </div>
      ) : (
        <>
          {lines.map((line) => (
            <ProductBand
              key={line.product}
              line={line}
              levels={levels}
              busyTankId={busyTankId}
              onOpenTank={(tank) => onOpenTank(line, tank)}
              onAddTank={() => onAddTank(line)}
              onOpenPump={(pump) => onOpenPump(line, pump)}
              onAddPump={() => onAddPump(line)}
              onToggleValve={(tank) => onToggleValve(line, tank)}
              onOpenLine={() => onOpenLine(line)}
            />
          ))}
          {remaining.length > 0 && (
            <AddCard
              label="Add a product line"
              hint={`(${remaining.join(', ')} available)`}
              onClick={onAddLine}
            />
          )}
        </>
      )}
    </div>
  )
}
